import { useEffect } from "react";

import { Events } from "@Context/common/general/context";
import VRHeaderButtonType from "@Enums/VRHeaderButtonType";
import useI18n from "@i18n";

interface UseSessionResultsHeaderButtonProps {
  headerButtonType: VRHeaderButtonType;
  onContinueClick: () => void;
}

export const useSessionResultsHeaderButton = ({ headerButtonType, onContinueClick }: UseSessionResultsHeaderButtonProps) => {
  const { i18n } = useI18n();

  useEffect(() => {
    const isBack = headerButtonType === VRHeaderButtonType.BACK;
    const actions = isBack
      ? undefined
      : [
          {
            label: i18n("continue"),
            onClick: onContinueClick,
          },
        ];

    Events.app.showHeaderButton.emit({
      type: headerButtonType,
      title: i18n("session-results.title"),
      ...(actions ? { actions } : {}),
    });

    return () => {
      Events.app.hideHeaderButton.emit();
    };
  }, [headerButtonType, i18n, onContinueClick]);
};
